import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  IMenuCarmiData,
  IMenuCssVars,
  IMenuDefinition,
  IMenuProperties,
} from '../Menu.types';
import {
  orientationToCssVarsMap,
  stretchedCssVars,
  notStretchedCssVars,
} from './utils/MapperUtils';
import { MenuOrientation } from '../constants';
import type { IMenuSDKData } from '@wix/editor-elements-corvid-utils/src/props-factories/menuUtils';

export const props = withCompInfo<
  IMenuProperties,
  IMenuDefinition,
  IMenuCarmiData
>()(['compData'], ({ compData }, carmiData) => {
  return {
    ...carmiData,
    ...compData,
  };
});

export const css = withCompInfo<IMenuCssVars, IMenuDefinition>()(
  ['styleProperties'],
  ({ styleProperties }) => {
    const {
      orientation = MenuOrientation.Horizontal,
      isContainerStretched = true,
    } = styleProperties;

    return {
      'min-width': 'min-content',
      ...(isContainerStretched ? stretchedCssVars : notStretchedCssVars),
      ...orientationToCssVarsMap[
        orientation as keyof typeof orientationToCssVarsMap
      ],
    };
  },
);

export const sdkData = withCompInfo<IMenuSDKData, IMenuDefinition>()(
  ['pagesMap'],
  ({ pagesMap }) => {
    return {
      pageList: pagesMap,
    };
  },
);

export default createComponentMapperModel({
  props,
  css,
  sdkData,
});
